<template>
  <div class="modal" id="modal-basic" ref="modal-basic" style="display: none">
    <div class="modal-inner">
      <div class="modal-content modal-sm alert-pop">
        <div class="modal-body">
          <div class="inner">
            <div class="icon-alert info">
              <div class="text">
                <p><strong class="modal-text"></strong></p>
              </div>
            </div>
            <div class="btn-box full-1">
              <button type="button" class="btn btn-dark ok">
                {{ $t('common.confirm') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PreRegistrationModal',
  };
</script>

<style scoped>
  .modal-text {
    white-space: pre-line;
  }
</style>
